"use client"
import React, { useCallback, useState } from "react"
import { toast } from "react-toastify"
import { deletePaymentMethod } from "../../../../../services/billing"
import { useBilling } from "../../../../../context/BillingContext"

const DeletePaymentModal = ({ show, onClose, data }) => {
  const [loading, setLoading] = useState(false)
  const { refetchPaymentMethods } = useBilling();

  if (!show) return null


  const handleCloseModal = useCallback(() => {
    setLoading(false)
    onClose()
  }, [onClose])

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault()
      try {
        setLoading(true)
        const response = await deletePaymentMethod(data?.id)
        await refetchPaymentMethods()
        toast.success(response?.data?.message || "Payment method deleted successfully", {
          position: "bottom-right",
        })
        handleCloseModal()
      } catch (err) {
        toast.error(
          err?.response?.data?.message || err?.message || "Failed to delete payment method",
          { position: "bottom-right" }
        )
      } finally {
        setLoading(false)
      }
    },
    [data?.id, refetchPaymentMethods, handleCloseModal]
  )

  return (
    <div
      className="modal d-flex align-items-center justify-content-center"
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1052,
      }}
      onClick={handleCloseModal}
    >
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-semibold">Delete Payment Method</h5>
            <div className="modal-close-btn">
              <button type="button" className="btn-close" onClick={handleCloseModal}></button>
            </div>
          </div>
          <div className="modal-body">
            <div className="mb-3 mt-3 ">
              Are you sure you want to delete this payment method?
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary flex-fill" onClick={handleCloseModal}>
              Cancel
            </button>
            <button
              className="btn plan-detail-card-btn flex-fill"
              type="button"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Deleting..." : "Delete Method"}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeletePaymentModal
